import { createTheme } from "@mui/material/styles";
import "typeface-roboto";
import variables from "theme/styles/_variables.module.scss";
import { Font } from "@react-pdf/renderer";
import MuseoSansRegularFont from "./fonts/MuseoSans-500.ttf";
import MuseoSansBoldFont from "./fonts/MuseoSans-700.ttf";

Font.register({
  family: "MuseoSans",
  fonts: [
    {
      src: MuseoSansRegularFont,
    },
    {
      src: MuseoSansBoldFont,
      fontWeight: 700,
    },
  ],
});

const WintTheme = createTheme({
  typography: {
    fontFamily: "Roboto",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 601,
      md: 901,
      lg: 1281,
      xl: 1585,
    },
  },
  palette: {
    primary: {
      light: variables.blueV3,
      main: variables.blueV2,
      dark: variables.blue,
      contrastText: variables.white,
    },
    secondary: {
      light: variables.lightGreen,
      main: variables.green,
      dark: variables.darkGreen,
      contrastText: variables.white,
    },
  },
});
export default WintTheme;
